import React from "react";
import { Text } from "../text/Text";

import "./Button.scss";

interface ButtonProps {
  text: string;
  onClick: () => void;
  className?: string;
}

const Button = ({ text, onClick, className }: ButtonProps) => {
  return (
    <button className={`btn ${className}`} onClick={onClick}>
      <Text text={text} size="xxs" fontWeight={600} />
    </button>
  );
};

export default Button;
